<template>
  <div id="login">
    <div class="container">
      <div class="loginBox">
        <div class="logo">

          <!-- <LogoSvg
            height="70px"
            style="color:#ffffff"
            alt="M Art"
          /> -->
          <span class="logo-icon"></span>
        </div>

        <!-- <h1>M Art 道具馆</h1> -->
        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
        >

          <a-form-item>
            <a-input
              v-decorator="[
                'phone',
                {
                  rules: [{ required: true, message: '手机号输入格式有误' , pattern: /^1[3456789]\d{9}$/ }],
                  validateTrigger: ['blur']
                }
              ]"
              placeholder="请输入注册时的手机号码"
            >
              <span class="phone-icon" slot="prefix"></span>
            </a-input>
          </a-form-item>
          <a-row type="flex" justify="space-between">
            <a-col span="15">
              <a-form-item
              >
                <a-input
                  autocomplete="false"
                  type="text"
                  v-decorator="[
                    'code',
                    {
                      rules: [{ required: true, message: '请输入验证码!' }]
                    }
                  ]"
                  placeholder="验证码"
                >
                  <span
                    slot="prefix"
                    class="chatCode"

                  ></span>
                </a-input>

              </a-form-item>
            </a-col>
            <a-col span="8">
              <a-button
                :disabled="codeState.sendBtn"
                :class="{'getCode-ing':codeState.isSend}"
                style="width: 100%; height:42px; border-radius:8px"
                v-text=" !codeState.isSend?'获取验证码': `${codeState.time}s`"
                @click.stop.prevent="getCode"
              >

              </a-button>
            </a-col>
          </a-row>

          <a-form-item>
            <a-input
              @change="passwordChange"
              autocomplete="false"
              v-decorator="[
                'password',
                {
                  rules: [{ required: true, message: '至少6位密码，区分大小写' }, {min:6, message: '最少输入6位密码'}]
                }
              ]"
              :type="(initExe1 || exe1)?'text':'password'"
              placeholder=" 密码"
            >
              <span @click="exe1 = !exe1" :class="[exe1?`exe_open`:`exe_close`]" slot="suffix" type="user" />
              <span class="pwd-icon" slot="prefix"></span>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              autocomplete="false"
              @change="cPasswordChange"
              v-decorator="[
                'confirm_password',
                {
                  rules: [
                    { required: true, message: '请填写确认密码!'},
                    {validator: compareToFirstPassword}]
                }
              ]"
              :type="(initExe2 || exe2)?'text':'password'"
              placeholder="确定密码"
            >
              <span @click="exe2 = !exe2" :class="[exe2?`exe_open`:`exe_close`]" slot="suffix" type="user" />
              <span class="pwd-icon" slot="prefix"></span>
            </a-input>
          </a-form-item>
          <a-button
            type="primary"
            @click="handleSubmit"
            class="login-form-button"
            style="width: 100%;height: 50px;border-radius:8px"
          >
            重置密码
          </a-button>
          <div style="text-align:center;margin-top:10px">
            <a-button type="link" @click="goHome">返回首页</a-button>
          </div>
        </a-form>

      </div>
    </div>
  </div>
</template>
<script>

export default {
  transition: 'fade',
  components: { },
  data () {
    return {
      choose: false,
      exe1: false,
      exe2: false,
      initExe1: true,
      initExe2: true,
      timer: null,
      agreeTimer: null,
      codeState: {
        isSend: false,
        time: 60,
        status: 'success',
        errorText: ''
      },
      showAgree: false,
      form: this.$form.createForm(this),
      activeAgree: 1,
      agree: {
        time: 5,
        status: false
      }
    }
  },
  beforeCreate () {

  },
  mounted () {
    // console.log(this.$axios.defaults.baseURL)
    if (localStorage.getItem('isFirstLogin')) {
      this.choose = true
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const res = await this.$api.user.resetPassword(values)
          if (res.status === 'error') {
            if (res.message.key === 1007) {
              this.form.setFields({
                code: {
                  errors: [new Error('*验证码错误')]
                }
              })
            } else if (res.message.key === 1011) {
              this.form.setFields({
                phone: {
                  errors: [new Error(`*${res.message.message}`)]
                }
              })
            }
          } else {
            this.$message.success('修改密码成功')
            this.$router.push({
              path: '/user/login'
            })
          }
        }
      })
    },
    passwordChange (e) {
      const value = e.target.value;
      this.initExe1 = !value.length;
    },
    cPasswordChange (e) {
      const value = e.target.value;
      this.initExe2 = !value.length;
    },
    checkRegister (rule, value, callback) {
      if (!value) {
        callback()
        return false
      }
      const params = {
        phone: value
      }
      this.$api.user.checkRegister(params).then(res => {
        if (res.status === 'ok') {
          if (res.data.result === 1) {
            callback()
          } else {
            callback(new Error('该手机号码还没被注册'))
          }
        } else {
          callback()
        }
      })
    },
    goHome () {
      this.$router.push({
        path: '/manage/chartlet'
      })
    },
    getCode () {
      this.form.validateFields(['phone'], (error, value) => {
        if (error || this.codeState.isSend) {
          return false
        }
        const params = {
          phone: value.phone,
          type: 1 // 1普通验证码  2注销验证码
        }

        this.$api.user.getVerifyCode(params).then(res => {
          if (res.message.key === 1006) {
            window.tncode.show()
            window.tncode.onSendResult((tn_check, key) => {
              console.log(tn_check, key)
              this.$api.user.getVerifyCode(Object.assign(params, { tn_check, key })).then(res => {
                if (res.status === 'ok') {
                  this.$message.success('发送成功')
                  this.codeState.isSend = true
                  this.timer = setInterval(() => {
                    this.codeState.time -= 1
                    if (this.codeState.time === 0) {
                      this.codeState.time = 60
                      this.codeState.isSend = false
                      clearInterval(this.timer)
                    }
                  }, 1000)
                  window.tncode.hide()
                } else {
                  window.tncode._showmsg(res.message.message)
                }
              })
            })
          } else if (res.message.key === 10000) {

          } else {
            this.codeState.isSend = true
            this.timer = setInterval(() => {
              this.codeState.time -= 1
              if (this.codeState.time === 0) {
                this.codeState.time = 60
                this.codeState.isSend = false
                clearInterval(this.timer)
              }
            }, 1000)
          }
        })
      })
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(new Error('与上方密码不同'))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="less" scoped>

#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
#login {
  position: relative;
  width: 100%;
  min-height: 100%;
  background: #f0f2f5 url(../../assets/img/bg.jpg) no-repeat 50%;
  background-size: 100%;
    background-position-y: 1px;
}

.container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .loginBox {
    width: 460px;
    padding-bottom: 50px;
    background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    /deep/
    .ant-form-item-control-wrapper {
        /deep/
        .ant-form-item-children{
          padding-left: 0px;
        }
    }
    /deep/
    .ant-input-affix-wrapper .ant-input {
      height: 42px;
      border-radius: 8px;
    }
    /deep/
    .ant-form-explain{
      margin: 6px 0 12px;
    }
    h1 {
      margin-bottom: 60px;
    }
    /deep/
    .ant-checkbox + span {
      display: inline-block;
      vertical-align: -6px;
    }
    .agreement {
        font-size:12px;color:#999999; width:288px;display:inline-block;line-height:24px;
        vertical-align: top;
    }
    .logo {
      width: 200px;
      height: 70px;
      margin-bottom: 40px;
      background-color:  @primary-color;
      border-radius: 0px 0px 20px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 142px;
        height: 25px;

      }
    }
    .reg-box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
      a {
        color: inherit;
      }
      span {
        font-size: 14px;
        cursor: pointer;
        &:hover{
          color: @primary-color;
        }
      }
    }
    .login-form {
      width: 320px;
      /deep/
      .ant-checkbox-checked .ant-checkbox-inner {
        background: none;
      }
      /deep/
      .ant-checkbox-checked .ant-checkbox-inner::after {
        border-color: @primary-color;
      }
    }
  }
}

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, sans-serif;
  display: block;
  font-weight: 300;
  font-size: 100px;
  color: #35495e;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 42px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.links {
  padding-top: 15px;
}

.ant-modal-body {
  padding: 0 24px;
}
.agree-modal {
  .title {
    color: @primary-color;
    text-align: center;
    font-size: 24px;
  }

  .ant-modal-body{
    padding: 0 24px;
  }
  .agree-content {
    padding: 0 24px;
    height: 512px;
    overflow: auto;
    margin-bottom: 25px;

  }
  .agree-btn{

    text-align:center
  }
}
</style>
